<script lang="ts" setup>
import { isCypressOrg } from '@/stores'

defineProps<{
  postId: string
}>()

const ROOT_EDIT_URL = `${import.meta.env.GHOST_API_URL}/ghost`
</script>

<template>
  <a
    v-if="isCypressOrg"
    class="flex h-[40px] items-center px-[16px] text-gray-500 transition-colors hover:text-indigo-500"
    :href="`${ROOT_EDIT_URL}/#/editor/post/${postId}`"
  >
    Edit post
  </a>
</template>
